
export enum Roles {
  Owner = 'Owner',
  Editor = 'Editor',
  Viewer = 'Viewer',
  Teacher = 'Teacher'
}
